import { createFileRoute } from '@tanstack/react-router'
import WorkspaceSummaryPage from '../../../../pages/workspace/[id]/sources/summary'

export const Route = createFileRoute('/(protected)/workspaces/$workspaceId/summary')({
  component: Summary,
})

function Summary() {
  return <WorkspaceSummaryPage />
} 